module.exports = __webpack_public_path__ + "img/slika67.d57fb763.jpg";